export const SPOT_SRC_MEMBERSHIP = {
    DIRECT_WEB: 'DIRECT_WEB',
    HOMELP_WEB: 'HOMELP_WEB',
    TRIALLANDINGPAGE_WEB: 'TRIALLANDINGPAGE_WEB',
    WEB: 'WEB',
    WEB_CALENDAR: 'WEB_CALENDAR',
    WEB_CHECKOUT: 'WEB_CHECKOUT',
    WEB_DETAIL_BADGE: 'WEB_DETAIL_BADGE',
    WEB_DETAIL_PRICING: 'WEB_DETAIL_PRICING',
    WEB_HOME: 'WEB_HOME',
    WEB_HOST_LINK: 'WEB_HOST_LINK',
    WEB_MEMBERSHIPS: 'WEB_MEMBERSHIPS',
    WEB_REVIEW_BADGE: 'WEB_REVIEW_BADGE',
    WEB_VISIT: 'WEB_VISIT',
    WEB_OPTIONAL_LOGIN: 'WEB_OPTIONAL_LOGIN',
};
